// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyBiPbm {
    'payorName'?: string | null;
    'phone'?: string | null;
    'responseMessage'?: string | null;
    'specialtyPharmacyRequirement'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyBiPbm>> = [
        {
            "name":     "payorName",
            "baseName": "payorName",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "responseMessage",
            "baseName": "responseMessage",
            "type":     "string"
        },
        {
            "name":     "specialtyPharmacyRequirement",
            "baseName": "specialtyPharmacyRequirement",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyBiPbm.attributeTypeMap;
    }
}
